export default __webpack_public_path__ + "static/media/flex_maly.4a35e8dc.png";